import { Vue, Component, Prop } from 'vue-property-decorator';
import Map from "@/components/map/Map";
import { IMapLayer } from "@/components/map/types";
import { User } from "@/components/User";
import { createUserLayer } from "../data/map.layers";
import { isMobile } from "@/common/utils";

import WMSCapabilities from 'ol/format/WMSCapabilities'; 
import WMTSCapabilities from 'ol/format/WMTSCapabilities'; 
import { L } from "@/common/filters";
import { APP_URL, APP_HOST } from "@/common/http";

@Component
export default class MapServiceClass extends Vue {
  @Prop({
    default: null
  }) data: {$mapService:any; $map:Map; mapStore:IMapLayer[]};

  $map: Map;
  mapLayerStore: IMapLayer[] = [];
  mapLayer: IMapLayer = { 
    header: 'ข้อมูลบริการอื่นๆ',
    children: []
  };
  serviceId: number = null;
  serviceName: string = null;
  serviceUrl: string = null;
  serviceType: "WMS" | "WMTS" = null;
  wmtsMatrixSet: string = null;
  wmtsEpsg: string = null;
  layerName: string = null;
  geomType: "Point" | "Line" | "Polygon" = null;

  layers:string[] = [];

  //authKey: string = null;
  userName: string = null;
  userPassword: string = null;

  hasTestedUrlOk:boolean = false;
    
  rules = {
    required: value => !!value || L('required')
  }

  resetForm() {
    this.serviceName = null;
    this.serviceType = null;
    this.serviceUrl = null;
    this.layerName = null;
    this.geomType = null;
    //this.authKey = null;
    this.userName = null;
    this.userPassword = null;
    this.layers = [];
    this.hasTestedUrlOk = false;
  }

  get hasRequiredInputs() : boolean {
    return !!this.serviceName && !!this.serviceType && 
            !!this.serviceUrl && !!this.layerName &&
            !!this.geomType;
  }

  get User() : User {
    return this.$store.getters.User;
  }

  get language() : string {
    return this.$store.getters.Language;
  };

  get WindowWidth() : number {
    return this.$store.getters.WindowWidth;
  }

  get isSmallOrMobile() : boolean {
    return isMobile() || this.WindowWidth<600;
  }

  gettingCapabilities:boolean = false;
  async getCapabilities() {
    try {
      this.serviceUrl = this.serviceUrl.replace(/\s+/g,'');
      if (!this.serviceUrl.match(/^http:\/\/|^https:\/\//i)) {
        this.serviceUrl = 'http://' + this.serviceUrl;
      }
      let n = this.serviceUrl.indexOf('?');
      let svc = 'service=' + this.serviceType + '&request=getcapabilities';
      let url;
      if (n>0) {
        url = this.serviceUrl.substr(0,n);
        svc += '&' + this.serviceUrl.substr(n+1);
      } else {
        url = this.serviceUrl;
      }
      url += '?' + svc;
      let options:any = {
        headers: {
          'Content-Type': 'application/xml'
        }
      }
      let re = new RegExp(APP_HOST,'gi');
      if (!this.serviceUrl.match(re)) { //cross domain
        options.url = url;
        url = 'proxy/';
      }
      this.gettingCapabilities = true;
      this.layers = [];
      let xml = await this.User.requestResource(url, 'GET', options);
      let parser, cap;
      if (this.serviceType.match(/WMS/i)) {
        parser = new WMSCapabilities();
        cap = parser.read(xml).Capability;
        if (cap && cap.Layer && cap.Layer.Layer) {
          this.layers = cap.Layer.Layer.map((layer) => {
            return layer.Name || layer.Identifier;
          });
        }
      } else {
        parser = new WMTSCapabilities();
        cap = parser.read(xml).Contents;
        if (cap && cap.Layer) {
          this.layers = cap.Layer.map((layer) => {
            return layer.Name || layer.Identifier;
          });
        }
        let epsg3857 = null;
        let epsg4326 = null;
        let epsgOther = null;
        let matrixSet;
        if (cap && cap.TileMatrixSet) {
          for (let i=0; i<cap.TileMatrixSet.length && !epsg3857; i++) {
            matrixSet = cap.TileMatrixSet[i].Identifier
            if (matrixSet.match(/\:3857$|\:900913$/)) {
              epsg3857 = matrixSet;
            } else if (matrixSet.match(/\:4326$/)) {
              epsg4326 = matrixSet;
            } else {
              epsgOther = matrixSet;
            }
          }
        }
        this.wmtsMatrixSet = this.wmtsEpsg = (epsg3857 || epsg4326 || epsgOther);
      }
      if (!this.layerName && !!this.layers && this.layers.length>0) {
        this.layerName = this.layers[0];
      }
      this.hasTestedUrlOk = true;
      this.gettingCapabilities = false;
    } catch (error) {
      this.gettingCapabilities = false;
      this.alertError(error.message || 'Test service fails');
    }
  }

  createLayer(id?:string) : IMapLayer {
    let url = this.serviceUrl.trim();
    let params:any = {};
    let n = url.indexOf('?');
    if (n>0) {
      let p = url.substr(n+1).split('&');
      url = url.substr(0,n).replace(/\s+/g,'').trim();
      for (let i=0; i<p.length; i++) {
        let kv = p[i].split('=');
        if (kv.length==2) {
          params[kv[0]] = kv[1];
        }
      }
    }
    
    if (!url.match(/^http:\/\/|^https:\/\//i)) {
      url = 'http://' + url;
    }
    let re = new RegExp(APP_HOST,'gi');
    if (!this.serviceUrl.match(re)) { //cross domain
      url = APP_URL + '/rest/proxy/?url=' + url;
    }
    let layer = createUserLayer({
      serviceId: this.serviceId || id,
      serviceName: this.serviceName,
      serviceType: this.serviceType,
      serviceUrl: url,
      layerName: this.layerName,
      params: params,
      geomType: this.geomType,
      wmtsMatrixSet: this.wmtsMatrixSet,
      wmtsEpsg: this.wmtsEpsg,
      //authKey: this.authKey,
      userName: this.userName,
      userPassword: this.userPassword,
      visible: true
    });
    this.$map.createOverlayLayers([layer]);
    return layer;
  }
  
  insertLayer(layer:IMapLayer) {
    let firstPointLayer = -1;
    let firstLineLayer = -1;
    let firstPolygonLayer = -1;
    let i;
    let layerIndex = -1;
    for (i=0; i<this.mapLayer.children.length; i++) {
      if (this.mapLayer.children[i].geomType=='Point') {
        if (layer.geomType=='Point') {
          layerIndex = i;
          break;
        }
        firstPointLayer = firstPointLayer==-1 ? i : firstPointLayer;
      } else if (this.mapLayer.children[i].geomType=='Line') {
        if (layer.geomType=='Line') {
          layerIndex = i;
          break;
        }
        firstLineLayer = firstLineLayer==-1 ? i : firstLineLayer;
      } else if (this.mapLayer.children[i].geomType=='Polygon') {
        if (layer.geomType=='Polygon') {
          layerIndex = i;
          break;
        }
        firstPolygonLayer = firstPolygonLayer==-1 ? i : firstPolygonLayer;
      }
    }
    if (layerIndex==-1) {
      if (layer.geomType=='Polygon') {
        layerIndex = this.mapLayer.children.length;
      } else if (layer.geomType=='Line') {
        layerIndex = firstPolygonLayer>=0 ? firstPolygonLayer : this.mapLayer.children.length;
      } else {
        layerIndex = firstLineLayer>=0 ? firstLineLayer : 
                     firstPolygonLayer>=0 ? firstPolygonLayer : this.mapLayer.children.length;
      }
    }
    let oLayer = layer.mapSources[0].nativeLayer;
    let mLayers = this.$map.map.NativeMap.getLayers();
    i = this.mapLayer.children.length;
    if (layerIndex>=i) {
      layerIndex = 0;
      for (i=0; i<mLayers.getLength(); i++) {
        if (mLayers.item(i)['geomType']==layer.geomType) {
          layerIndex = i;
          break;
        }
      }
      mLayers.insertAt(layerIndex,layer.mapSources[0].nativeLayer);
      this.mapLayer.children.push(layer);
    } else {
      i = mLayers.getArray().indexOf(this.mapLayer.children[layerIndex].mapSources[0].nativeLayer);
      mLayers.insertAt(i+1,layer.mapSources[0].nativeLayer);
      this.mapLayer.children.splice(layerIndex,0,layer);
    }
    layer.parent = this.mapLayer;
  }

  alertError(message) {
    this.$store.commit('notifyChange', {
      Dialog: {
        Type: 'error',
        Title: 'error',
        Message: message,
        OkText: null,
        CancelText: 'close',
        show: true,
        OnClose: null
      }
    });
  }
}
